import { Paper, Typography } from '@material-ui/core';
import React from 'react';
import { useStyle } from './useStyle';

const AreaCard = ({ title }) => {
	const classes = useStyle();
	return (
		<Paper className={classes.paper} elevation={0}>
			<div className={classes.greenLabel}></div>
			<Typography variant='h4' className={classes.title}>
				{title}
			</Typography>
		</Paper>
	);
};

export default AreaCard;
